import fetch from 'isomorphic-unfetch';

import { apiHeaders } from '../generic';

import { uuidv4 } from '../../../utils/generic';

export default class OtpApis {
  static verifyOtp = async (user_id, otp) => {
    const url = `${process.env.MARKETPLACE_API_URL}/api/v1/auth/validate_otp`;
    const headers = {
      'Content-Type': 'application/json',
      'X-Request-Id': `awign_ui_${uuidv4()}`
    };
    const otp_token = localStorage.getItem('otp_token');

    if (otp_token) {
      headers['access-token'] = otp_token;
    }

    const reqBody = {
      user: {
        otp
      }
    };

    return fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(reqBody)
    });
  };

  static generateOtp = async (user_id) => {
    const url = `${process.env.AUTH_SERVICE}api/v1/users/${user_id}/generate_otp`;
    const headers = apiHeaders();

    return fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify({})
    });
  };
}
